<template>
  <div>
    <div class="e-card" style="margin-top: 5px">
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(4, 1fr); column-gap: 5%"
      >
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="applicationTypeDS"
          :fields="applicationTypeFields"
          placeholder="Application Type"
          v-model="applicationType"
        />
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="dateTypeDS"
          :fields="dateTypeFields"
          placeholder="Date Type"
          v-model="dateType"
        />
        <ejs-datepicker
          float-label-type="Always"
          v-model="date"
          placeholder="Date"
          format="dd/MM/yyyy"
        />
        <div style="width: 2%; padding-top: 4%">
          <ejs-button
            type="button"
            cssClass="e-danger"
            v-on:click.native="onOkButtonClick"
            :disabled="isButtonDisabled"
          >
            Ok
          </ejs-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 5px">
      <ejs-grid
        ref="grid"
        :dataSource="reportDS"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :created="created"
        :toolbarClick="toolbarClick"
        :excelQueryCellInfo="excelQueryCellInfo"
        :allowExcelExport="true"
        height="100%"
        width="100%"
      >
        <e-columns>
          <e-column field="glCode" headerText="Account Id" textAlign="Left" width="200" />
          <e-column field="glValue"
            headerText="Transaction Amount"
            textAlign="Left"
            format="C2"
            width="120" />
          <e-column
            field="descriptions"
            headerText="Transaction Description"
            textAlign="Left"
            width="250"
          />
          <e-column
            field="searchDate"
            headerText="Transaction/Invoice date"
            textAlign="Left"
            width="200"
            type="date"
            :format="gridDateFormat"
          />
          <e-column
            field="applicationType"
            headerText="Application Type"
            textAlign="Left"
            width="200"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js'

import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { applicationTypes, fetchSageReports } from '../services/usercredits-api';

Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'SageReports',
  data() {
    return {
      applicationType: '',
      dateType: 'invoiceDate',
      date: null,
      applicationTypeDS: [{ id: '', appType: 'All' }],
      applicationTypeFields: { text: 'appType', value: 'id' },
      dateTypeDS: [
        { id: 'invoiceDate', dateType: 'Invoice date' },
        { id: 'paymentDate', dateType: 'Transaction date' },
      ],
      dateTypeFields: { text: 'dateType', value: 'id' },
      reportDS: null,
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 15 },
      gridDateFormat : getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    isButtonDisabled() {
      return !this.dateType || !this.date;
    },
  },
  async created() {
    const appTypes = await applicationTypes();
    const typeList = appTypes.data.map(item => item.category);
    [...new Set(typeList)].forEach((t) => this.applicationTypeDS.push({ id: t, appType: t }));
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      // const dateType = this.dateType === 'Transaction date' ? 'paymentdate' : 'invoicedate';
      const report = await fetchSageReports(this.dateType, this.date, this.applicationType);
      this.reportDS = report.data;
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Sage Report.xlsx'),
          });
          break;
      }
    },
    excelQueryCellInfo(args) {
      switch(args.column.field){
        case 'searchDate':
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
  },
};
</script>
